import { all, takeEvery, put, fork, call } from 'redux-saga/effects';

import { success } from '../actions/ComplainlistActions';
import ComplainlistService from '../../services/ComplainService';
import { COMPLAIN_LIST_LOADDATA } from '../constants/ComplainlistConst';

export function* loaddata() {
  yield takeEvery(COMPLAIN_LIST_LOADDATA, function* (payload) {
    try {
      const res = yield call(ComplainlistService.getAll, payload);
      console.log('->>>>>>>>>>');
      yield put(success(res.data.data));
      console.log(res);
    } catch (err) {
      console.log('->>>>>>>>>> error');
      console.log(err);
    }
  });
}

export default function* rootSaga() {
  yield all([fork(loaddata)]);
}
